import {
  RequestProvider,
  AuthorisationConsumer,
  CreditsConsumer
} from '@shootsta/common-react';
import {
  getPaymentInvoiceQuery,
  getTransactionByOrderIdQuery,
  getContractsQuery
} from '../api';

import PaymentStatusModalComponent from '../components/PaymentStatusModal';

interface PaymentStatusModal {
  visible: boolean;
  history: any;
}

const PaymentStatusModal = (props: PaymentStatusModal) => {
  return (
    <AuthorisationConsumer>
      {({ selectedOrganisation: { organisationId } }: any) => (
        <RequestProvider
          requests={{
            getPaymentInvoice: getPaymentInvoiceQuery(organisationId),
            getTransactionByOrderId:
              getTransactionByOrderIdQuery(organisationId),
            getContracts: getContractsQuery(organisationId)
          }}
        >
          {({
            getPaymentInvoice,
            getTransactionByOrderId,
            getContracts
          }: {
            getPaymentInvoice: Function;
            getTransactionByOrderId: Function;
            getContracts: Function;
          }) => (
            <CreditsConsumer>
              {({
                actions: { onCreditsUpdated }
              }: {
                actions: { onCreditsUpdated: () => void };
              }) => (
                <PaymentStatusModalComponent
                  getPaymentInvoice={getPaymentInvoice}
                  getTransactionByOrderId={getTransactionByOrderId}
                  getContracts={getContracts}
                  onCreditsUpdated={onCreditsUpdated}
                  {...props}
                />
              )}
            </CreditsConsumer>
          )}
        </RequestProvider>
      )}
    </AuthorisationConsumer>
  );
};

export default PaymentStatusModal;
